import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { ALL_TAG } from './constants';
import {
  AllListTagSuccess,
  AllListTagError,
  AllListTagDataActionTypes,
  IAllTagState,
} from './types';

const initialState: IAllTagState = {
  status: idle,
  entities: null,
  error: null,
};

export default produce(
  (draft = initialState, action: AllListTagDataActionTypes): IAllTagState => {
    switch (action.type) {
      case ALL_TAG + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ALL_TAG + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AllListTagSuccess).payload.items;
        break;
      }
      case ALL_TAG + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AllListTagError).error;
        break;
      }
      case ALL_TAG + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
